// src/components/common/FabSaveButton.js
import React from 'react';
import { Save, Loader2 } from 'lucide-react';

const FabSaveButton = ({ onClick, label = 'Salvar', loading = false, disabled = false, visible = true, type = 'submit' }) => {
    if (!visible) return null;

    return (
        <button
            type={type}
            className="fab-save-btn"
            onClick={onClick}
            disabled={disabled || loading}
            aria-label={label}
        >
            {loading ? <Loader2 size={18} className="icon animate-spin" aria-hidden="true" /> : <Save size={18} className="icon" aria-hidden="true" />}
            {loading ? 'Salvando...' : label}
        </button>
    );
};

export default FabSaveButton;
